/** Which milestones are new to the learner. What counts as one is `tutor_core::milestone`'s. */

export type MilestoneRow = {
  kind: string;
  detail?: string | null;
  achievedAt: string;
};

/**
 * Those after `seenAt`, newest first. A learner who never looked (`null`)
 * gets none, rather than months of old news; the caller marks them seen.
 */
export function unseen(milestones: readonly MilestoneRow[], seenAt: string | null): MilestoneRow[] {
  if (seenAt === null) return [];
  const since = Date.parse(seenAt);
  return milestones
    .filter((m) => Date.parse(m.achievedAt) > since)
    .sort((a, b) => Date.parse(b.achievedAt) - Date.parse(a.achievedAt));
}

export function newestAt(milestones: readonly MilestoneRow[]): string | null {
  let newest: string | null = null;
  for (const m of milestones) {
    if (newest === null || Date.parse(m.achievedAt) > Date.parse(newest)) newest = m.achievedAt;
  }
  return newest;
}
